import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Children, useCallback, useMemo, useState } from 'react';
import styled, { theme } from '../../../utils/Styling';
import UIPanel from 'UIComponents/panel/UIPanel';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UICaret from 'UIComponents/icon/icons/UICaret';
import FullScreenModal from './FullScreenModal';
import UIFlex from 'UIComponents/layout/UIFlex';
import { FormattedMessage } from '../../I18n';
export const ItemsWrapper = styled.div.withConfig({
  displayName: "MobileNestedMenu__ItemsWrapper",
  componentId: "vu1pcf-0"
})(["", " & button{width:100%;}> *{padding:", ";border-bottom:1px solid ", ";}"], props => props.$indented && `margin-left: 20px;`, props => props.$indented ? '12px 24px 12px 0' : '0', theme.colors.GREAT_WHITE);
export const CaretForward = styled(UICaret).withConfig({
  displayName: "MobileNestedMenu__CaretForward",
  componentId: "vu1pcf-1"
})(["height:12px;width:7px;margin:0 8px 0 9px;"]);
const CaretBack = styled(CaretForward).withConfig({
  displayName: "MobileNestedMenu__CaretBack",
  componentId: "vu1pcf-2"
})(["transform:rotate(180deg);margin-right:10px;margin-left:-10px;"]);
const BackClickArea = styled.span.withConfig({
  displayName: "MobileNestedMenu__BackClickArea",
  componentId: "vu1pcf-3"
})(["padding:10px;cursor:pointer;"]);
const MenuHeader = styled(UIFlex).withConfig({
  displayName: "MobileNestedMenu__MenuHeader",
  componentId: "vu1pcf-4"
})(["height:40px;background-color:", ";color:", ";"], theme.colors.PANTERA, theme.colors.OLAF);
const MenuPanelHeader = styled(UIPanelHeader).withConfig({
  displayName: "MobileNestedMenu__MenuPanelHeader",
  componentId: "vu1pcf-5"
})(["background:", " !important;margin-left:-10px;"], theme.colors.PANTERA);
const SubHeader = styled(UIFlex).withConfig({
  displayName: "MobileNestedMenu__SubHeader",
  componentId: "vu1pcf-6"
})(["height:35px;padding:0 20px;background-color:#28333e;color:", ";align-items:center;"], theme.colors.OLAF);

const Header = ({
  useSidePanel,
  children
}) => {
  if (useSidePanel) {
    return /*#__PURE__*/_jsx(MenuPanelHeader, {
      children: children
    });
  }

  return /*#__PURE__*/_jsx(MenuHeader, {
    children: children
  });
};

const Container = (_ref) => {
  let {
    useSidePanel,
    children
  } = _ref,
      fullScreenModalProps = _objectWithoutPropertiesLoose(_ref, ["useSidePanel", "children"]);

  if (useSidePanel) {
    return /*#__PURE__*/_jsx(UIPanel, {
      width: "100%",
      children: children
    });
  }

  return /*#__PURE__*/_jsx(FullScreenModal, Object.assign({}, fullScreenModalProps, {
    children: children
  }));
};

const MobileNestedMenu = (_ref2) => {
  let {
    children,
    indented,
    setIsOpen,
    open,
    selectedPage = -1,
    subHeading,
    useBackText,
    useSidePanel
  } = _ref2,
      restProps = _objectWithoutPropertiesLoose(_ref2, ["children", "indented", "setIsOpen", "open", "selectedPage", "subHeading", "useBackText", "useSidePanel"]);

  const [page, showPage] = useState(selectedPage);
  const close = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  const goBack = () => {
    showPage(-1);
  };

  const flatChildren = useMemo(() => {
    const allChildren = [];
    Children.toArray(children).forEach(child => {
      const item = child;

      if (item.props.nestedOptions) {
        allChildren.push(...item.props.children);
      } else allChildren.push(child);
    });
    return allChildren;
  }, [children]);
  const pages = flatChildren.map(child => {
    if (!child) return '';
    const item = child;
    const {
      props: {
        subpage
      } = {}
    } = item;
    return subpage || '';
  }) || [];

  const renderHeader = () => {
    return /*#__PURE__*/_jsxs(Header, {
      useSidePanel: useSidePanel,
      children: [page >= 0 && /*#__PURE__*/_jsxs(BackClickArea, {
        onClick: goBack,
        children: [/*#__PURE__*/_jsx(CaretBack, {
          color: theme.colors.OLAF
        }), ' ', useBackText && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.common.back"
        })]
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        "data-test-id": 'nested-menu-close-btn',
        onClick: close
      })]
    });
  };

  const renderBody = () => {
    return /*#__PURE__*/_jsx(ItemsWrapper, {
      $indented: indented,
      children: page < 0 ? flatChildren.map((child, key) => {
        return child && /*#__PURE__*/_jsx("div", {
          onClick: () => pages[key] && showPage(key),
          children: child
        }, key);
      }) : pages[page]
    });
  };

  return /*#__PURE__*/_jsxs(Container, Object.assign({
    headerContent: useSidePanel ? null : renderHeader(),
    open: open,
    showCloseButton: false,
    subheader: subHeading ? /*#__PURE__*/_jsx(SubHeader, {
      children: /*#__PURE__*/_jsx("small", {
        children: subHeading
      })
    }) : null,
    useSidePanel: useSidePanel
  }, restProps, {
    children: [useSidePanel && renderHeader(), renderBody()]
  }));
};

export default MobileNestedMenu;